let config;

const getStandaloneConfig = async () => {
    if (!config) {
        if (process.env.REACT_APP_ENV === 'dev') {
            config = (
                await import(/* webpackChunkName: "lazy-chunk.standalone-config-dev" */ './countryCodeConfig-dev')
            ).default;
        }
        if (process.env.REACT_APP_ENV === 'stg') {
            config = (
                await import(/* webpackChunkName: "lazy-chunk.standalone-config-stg" */ './countryCodeConfig-stg')
            ).default;
        }
        if (process.env.REACT_APP_ENV === 'qa') {
            config = (await import(/* webpackChunkName: "lazy-chunk.standalone-config-qa" */ './countryCodeConfig-qa'))
                .default;
        }
        if (process.env.REACT_APP_ENV === 'qa-preprod') {
            config = (
                await import(
                    /* webpackChunkName: "lazy-chunk.standalone-config-preprod" */ './countryCodeConfig-preprod'
                )
            ).default;
        }
    }

    return config;
};

export default {
    getStandaloneConfig,
};
